module.exports = __webpack_public_path__ + "static/media/fullsize.b7d334b1.png";